import React, { PropTypes } from 'react';

import { black, white as whiteFill, link as linkStyle } from './styles.module.css';

const Close = ({
  className,
  link,
  onClose,
  white,
}) => (
  <svg width="11" height="11" viewBox="0 0 11 11" xmlns="http://www.w3.org/2000/svg" onClick={onClose} className={[className, white ? whiteFill : black, link && linkStyle].join(' ')}><path d="M6.95 5.536l3.416 3.416a1.003 1.003 0 0 1-.002 1.412.996.996 0 0 1-1.412.002L5.536 6.95l-3.417 3.416a1.003 1.003 0 0 1-1.412-.002.996.996 0 0 1-.002-1.412l3.416-3.416L.705 2.119A.996.996 0 0 1 .707.707 1.003 1.003 0 0 1 2.12.705l3.417 3.416L8.952.705a.996.996 0 0 1 1.412.002c.39.39.387 1.028.002 1.412L6.95 5.536z" fillRule="evenodd" /></svg>
);

export default Close;

Close.propTypes = {
  /*
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /*
   * Prop to determine if cross needs padding (easier for user to click on).
   */
  link: PropTypes.bool,
  /*
   * Prop to determine color of cross.
   */
  white: PropTypes.bool,
  /**
   * Callback called when the portal closes
   */
  onClose: PropTypes.func,
};

Close.defaultProps = {
  className: '',
  link: false,
  onClose: undefined,
  white: false,
};



// WEBPACK FOOTER //
// ./app/src/components/Close/index.jsx